import { DeviceType } from '@repo/types';
import { useDeviceType } from '@ui/utils/useDeviceType';

export const useIsMobile = () => {
  const deviceType = useDeviceType();
  return deviceType === DeviceType.mobile;
};
